import Constants from '@usas/ui-web/utils/Constants';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOmeMeetOrgUnitEntryRosterPermissionsData from './GetOmeMeetOrgUnitEntryRosterPermissionsData';
import putOmeMeetOrgUnitEntryRosterPermissionsData from './PutOmeMeetOrgUnitEntryRosterPermissionsData';

export const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  omeMeetOrgUnitEntryId: Constants.DEFAULT_ID
};

const OmeMeetOrgUnitEntryRosterPermissionsData = {
  getOmeMeetOrgUnitEntryRosterPermissionsData,
  putOmeMeetOrgUnitEntryRosterPermissionsData,
  INITIAL_STATE
};

export default OmeMeetOrgUnitEntryRosterPermissionsData;